import { Controller } from '@hotwired/stimulus';
import Chart from 'chart.js/auto';
import merge from 'lodash.merge';

export default class extends Controller {
  static targets = ['data', 'canvas'];

  connect() {
    window.Chart = Chart;
    this.chart = new Chart(
      this.canvasTarget,
      merge(
        {
          options: {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 2,
            plugins: {
              legend: {
                labels: {
                  font: {
                    family: "'DM Sans', sans-serif",
                  },
                },
              },
            },
          },
        },
        JSON.parse(this.dataTarget.innerText),
      ),
    );
  }

  disconnect() {
    this.chart.destroy();
  }

  download() {
    const png = this.chart.toBase64Image('image/png', 1.0);
    const link = document.createElement('a');
    link.download = 'chart.png';
    link.href = png;
    link.click();
    link.remove();
  }

  downloadCSV() {
    const csv = Array.from(this.chart.data.datasets).map((dataset) => {
      if (dataset.data instanceof Array) {
        return Array.from(dataset.data).map((value, index) => `${this.chart.data.labels[index]},${value}`).join('\n');
      }
      if (dataset.data instanceof Object) {
        return Object.keys(dataset.data).map((key) => `${key},${dataset.data[key]}`).join('\n');
      }
      return '';
    }).join('\n\n');
    const link = document.createElement('a');
    link.download = 'chart.csv';
    link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
    link.click();
    link.remove();
  }
}
